/*
 * Created Date: 08-10-2021, 2:59:23 pm
 * Author: Trần Quang Hùng
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2021 VNE E-COMMERCE, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { Checkbox, FormControlLabel, FormHelperText, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { Controller } from 'react-hook-form'

const FormCheckbox = ({ className, control, name, label, labelClassName, ...restProps }) => {
	// const { className, control, name, label, labelClassName, ...restProps } = props

	return (
		<div className={className}>
			<FormControlLabel
				className={labelClassName}
				control={
					<Controller
						control={control}
						name={name}
						render={({ field: { onChange, value, ref }, fieldState: { error } }) => {
							return (
								<>
									<Checkbox
										color="primary"
										onChange={e => onChange(e.target.checked)}
										checked={Boolean(value)}
										ref={ref}
										{...restProps}
									/>
									{error && error.message && <FormHelperText error>{error.message}</FormHelperText>}
								</>
							)
						}}
					/>
				}
				label={label ? <Typography>{label}</Typography> : undefined}
			/>
		</div>
	)
}

FormCheckbox.defaultProps = {
	className: null
}

FormCheckbox.propTypes = {
	className: PropTypes.string,
	control: PropTypes.object.isRequired,
	name: PropTypes.string.isRequired,
	label: PropTypes.any.isRequired,
	labelClassName: PropTypes.string
}

export default React.memo(FormCheckbox)
